<template>
  <div class="custom-collapse">
    <div
      v-if="isCollapse !== false"
      class="custom-collapse__switch"
      @click="changeOpen"
    >
      <span v-if="!isOpen">
        {{ $t('i18n_display_filter') }}
        <a-icon type="down" />
      </span>
      <span v-else>
        {{ $t('i18n_collapse_filter') }}
        <a-icon type="up" />
      </span>
    </div>
    <div
      :class="{
        'custom-collapse__area--active': isOpen,
        'custom-collapse__area': true
      }"
    >
      <a-form class="ignore" layout="inline">
        <div class="custom-collapse__area__header">
          <slot name="header" />
        </div>
        <transition
          @after-enter="afterEnter"
          @after-leave="afterLeave"
          @enter="enter"
          @leave="leave"
        >
          <div v-show="isOpen" class="custom-collapse__area__content">
            <slot name="content" />
          </div>
        </transition>
      </a-form>
      <div
        :class="{
          'custom-collapse__area--active': isOpen,
          'custom-collapse__area__button': true
        }"
      >
        <slot name="button" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * props參數說明 - By Noey 2019.11.25
 * isCollapse: 是否顯示switch按鈕
 * contentOpen: 預設搜尋detail是展開還收合
 */
export default {
  props: ['isCollapse', 'contentOpen'],
  data() {
    return {
      isOpen: null,
      window: {
        width: 0
      }
    }
  },
  mounted() {
    this.isOpen =
      typeof this.contentOpen === 'boolean' ? this.contentOpen : true
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  updated() {
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    changeOpen() {
      this.isOpen = !this.isOpen
    },
    handleResize() {
      if (this.isOpen) {
        let dom = document.querySelector('.custom-collapse__area__content')
        this.resize(dom)
      }
    },
    enter: function(el) {
      el.style.height = 'auto'
      let endWidth = window.getComputedStyle(el).height
      el.style.height = '0px'
      el.offsetHeight
      el.style.height = endWidth
    },
    afterEnter: function(el) {
      let endWidth = window.getComputedStyle(el).height
      el.style.height = endWidth
    },
    leave: function(el) {
      el.style.height = window.getComputedStyle(el).height
      el.offsetHeight
      el.style.overflow = 'hidden'
      el.style.height = '0px'
    },
    afterLeave: function(el) {
      el.style.height = null
    },
    resize(el) {
      el.style.height = null
    }
  }
}
</script>
